import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { MCButton, MCText, View } from 'src/components/basic';
import { remCss, workingTimes } from '../utils';
import { addressObject, userFullName } from 'src/helpers';
import { BASE_ICONS } from 'src/components/svg';
import LANG_CONST from 'src/helpers/lang/const';
import { StaticGoogleMap } from 'src/components/location/GoogleMaps';

// export const SubLocation = ({ manager, clinic, location, onSendMsg }) => {
//   return (
//     <View style={{ gap: remCss(40) }}>
//       <View style={{ gap: remCss(20) }}>
//         <MCText size={25} weight={500} heading label={userFullName(clinic)} />
//         <View style={{ flexDirection: 'row', gap: remCss(10) }}>
//           <SVGIcon
//             iconname={BASE_ICONS.PHONE_FILL}
//             width={25}
//             fill={scssVariables['colors-mc-primary']}
//             light
//             radius
//           />
//           <MCText
//             size={18}
//             weight={400}
//             lineHeight={25}
//             textLight
//             label={formatPhoneNumberIntl((clinic.phoneNumber || '').toString())}
//           />
//         </View>
//         <View style={{ flexDirection: 'row', gap: remCss(10) }}>
//           <SVGIcon
//             iconname={BASE_ICONS.EMAIL}
//             width={25}
//             fill={scssVariables['colors-mc-primary']}
//             light
//             radius
//           />
//           <MCText size={18} weight={400} lineHeight={25} textLight label={clinic.email} />
//         </View>
//       </View>
//       {onSendMsg && manager?.id && (
//         <MCButton
//           label={LANG_CONST.buttons.chat_support}
//           largeMedium
//           primary
//           dark
//           radius
//           onClick={(e) => {
//             e.preventDefault();
//             setTimeout(() => {
//               window.scrollTo({
//                 top: 150
//               });
//             }, 100);
//             onSendMsg(manager, location);
//             e.stopPropagation();
//           }}
//         />
//       )}
//       {location && (
//         <div className={'mc-b2 mc-plr15 mc-ptb10 mc-radius-5'}>
//           <div className={'mc-flex-0-col'} style={{ whiteSpace: 'normal' }}>
//             <MCText size={18} weight={500} text>
//               {location.hospital?.split('_')[0]}
//             </MCText>
//             <MCText size={16} textLight>
//               {
//                 addressObject({
//                   cityAddress: location.city,
//                   stateAddress: location.state,
//                   countryAddress: location.country
//                 }).fullAddressNameReverse
//               }
//             </MCText>
//           </div>
//         </div>
//       )}
//     </View>
//   );
// };
//
// export const Location = ({ clinic, onSendMsg, location, manager }) => {
//   return (
//     <View
//       style={{
//         gap: remCss(40)
//       }}
//     >
//       <SubLocation location={location} onSendMsg={onSendMsg} clinic={clinic} manager={manager} />
//       <View style={{ gap: remCss(20) }}>
//         <MCText label={LANG_CONST.schedule} size={22} weight={500} heading />
//         <View
//           style={{
//             display: 'grid',
//             gridTemplateColumns: `repeat(2, minmax(${remCss(210)}px, 1fr))`,
//             gap: remCss(20)
//           }}
//         >
//           {dateOfWeek.map((d) => {
//             const data = (!!location?.schedule && location?.schedule[d.toLowerCase()]) || {};
//             const times = (data?.times || []).filter((t) => t.startTime && t.endTime);
//             return (
//               <View key={d} style={{ gap: remCss(10) }}>
//                 <MCText label={d} size={20} weight={500} heading />
//                 {!data?.isOpen || times.length === 0 ? (
//                   <MCText label={'Closed'} size={18} weight={500} quaternary />
//                 ) : (
//                   times.map((t, i) => (
//                     <MCText
//                       key={i}
//                       label={
//                         moment(t.startTime).format('HH:mm') +
//                         ' - ' +
//                         moment(t.endTime).format('HH:mm')
//                       }
//                       size={18}
//                       weight={500}
//                       quaternary
//                     />
//                   ))
//                 )}
//               </View>
//             );
//           })}
//         </View>
//       </View>
//       {location && (
//         <GoogleMaps lat={location.location.latitude} lng={location.location.longitude} />
//       )}
//     </View>
//   );
// };

export const SubLocation = ({ isLeft, clinic, onChatSupport, location, emptyManagers }) => {
  const [loading, setLoading] = React.useState(false);
  return (
    <View
      style={
        isLeft
          ? { gap: remCss(40) }
          : {
              paddingBottom: remCss(60),
              paddingHorizontal: remCss(30),
              gap: remCss(40),
              flexDirection: 'row',
              flexWrap: 'wrap'
            }
      }
    >
      <View style={{ gap: remCss(20), flex: 1, minWidth: '50%' }}>
        <MCText
          size={25}
          weight={500}
          heading
          label={
            userFullName(clinic) +
            (location
              ? ' - ' +
                addressObject({
                  countryAddress: location.country,
                  cityAddress: location.city,
                  stateAddress: location.state
                }).shortAddressNameReverse
              : '')
          }
        />
        <View style={{ flexDirection: 'row', gap: remCss(10) }}>
          <MCButton iconname={BASE_ICONS.PHONE_FILL} width={25} primary light radius padding={1} />
          <MCText
            size={18}
            weight={400}
            lineHeight={25}
            textLight
            label={formatPhoneNumberIntl((clinic.phoneNumber || '').toString())}
          />
        </View>
        <View style={{ flexDirection: 'row', gap: remCss(10) }}>
          <MCButton iconname={BASE_ICONS.EMAIL} width={25} primary light radius padding={1} />
          <MCText size={18} weight={400} lineHeight={25} textLight label={clinic.email} />
        </View>

        {onChatSupport && !emptyManagers && (
          <MCButton
            label={LANG_CONST.buttons.chat_support}
            largeMedium
            primary
            dark
            radius
            loading={loading}
            disabled={loading}
            style={{ maxWidth: remCss(380) }}
            onClick={(e) => {
              e.preventDefault();
              onChatSupport(location, setLoading);
              e.stopPropagation();
            }}
          />
        )}
        {location && (
          <View style={{ flexDirection: 'row', gap: remCss(10) }}>
            <MCButton iconname={BASE_ICONS.LOCATION} width={25} primary light radius padding={1} />
            <MCText
              size={18}
              weight={400}
              lineHeight={25}
              textLight
              label={location.hospital?.split('_')[0]}
            />
          </View>
        )}
        <View style={{ flexDirection: 'row', gap: remCss(10) }}>
          <MCButton iconname={BASE_ICONS.CLOCK} width={25} primary light radius padding={8} />
          <View>
            {workingTimes(!location?.schedule ? null : location?.schedule).map((item, i) => (
              <MCText
                label={item.day + ': ' + item.time}
                size={18}
                weight={400}
                textLight
                key={i}
              />
            ))}
          </View>
        </View>
      </View>
      {location && (
        <View style={{ maxWidth: remCss(380) }}>
          <StaticGoogleMap lat={location.location.latitude} lng={location.location.longitude} />
        </View>
      )}
    </View>
  );
};
